import React, { useRef, useState } from 'react';
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";

import {Button} from 'primereact/button';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import { OverlayPanel } from 'primereact/overlaypanel';

import _ from "lodash";
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';


const StepsTable = ({formik, objectPath, name, title, description, indexColumnName, addRowName, valuesList, disabled, hideSteps, topAligned}) => {
	const infoButtonsOverlay = useRef((valuesList || []).map(e => e.key));
	const [selectedInfoButtonMessage, setSelectedInfoButtonMessage] = useState("");
	const [displayDialogEdit, setDisplayDialogEdit] = useState(false);
	const [innerComponentProps, setInnerComponentProps] = useState();

	const getEditableObject = (values) => {
		if(!objectPath)
		{
			return values;
		} else {
			return _.get(values, objectPath)
		}
	}

	const dataTableObj = getEditableObject(formik.values)[name];


	const handleAddRow = () => {
		const newValuesObj = formik.values;
		const editableObject = getEditableObject(newValuesObj);
		if(!editableObject[name])
		{
			editableObject[name] = [];
		}

		const listOfSteps = editableObject[name].map(e => e?.step);
		const initialObject = {
			step: (listOfSteps?.length? Math.max(...listOfSteps) + 1 : 1)
		};

		//build list of fields
		if(valuesList) {
			valuesList.forEach((e)=>initialObject[e?.key] = "");
		} else {
			initialObject.value = "";
		}

		if(!topAligned) {
			editableObject[name].push(initialObject);
		} else {
			editableObject[name].unshift(initialObject);
		}

		formik.setValues({...newValuesObj});
	}

	const removeRow = (rowData) => {
		const newValuesObj = formik.values;
		const editableObject = getEditableObject(newValuesObj);

		editableObject[name] = editableObject[name].filter(e => e?.step !== rowData?.step);

		formik.setValues({...newValuesObj});
	}

	const textEditor = (options, valueObj) => {

		if(valueObj?.inputType === "InputTextarea") {
			return <InputTextarea type="text"
								  autoResize
								  value={options.value}
								  onChange={(e) => options.editorCallback(e.target.value)}
								  placeholder={valueObj?.inputPlaceholder}
								  rows="6"/>;
		} else if(valueObj?.inputType === "Dropdown") {
			const optionsIsFunction = typeof (valueObj?.inputOptions || []) === "function";
			return <Dropdown type="text"
								  value={options.value}
								  onChange={(e) => options.editorCallback(e.target.value)}
								  placeholder={valueObj?.inputPlaceholder}
								  options={optionsIsFunction? valueObj.inputOptions(options?.rowData) : (valueObj?.inputOptions || [])}
								  optionLabel='label'
								  optionValue='key'/>;
		} else {
			return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} placeholder={valueObj?.inputPlaceholder}/>;
		}
	}



	const onCellEditComplete = (e) => {
		let { rowIndex, newRowData, originalEvent: event } = e;
		const newValuesObj = formik.values;
		const editableObject = getEditableObject(newValuesObj);
		editableObject[name][rowIndex] = newRowData;

		formik.setValues({...newValuesObj});
		if(event?.target?.type === "textarea") {
			event.stopImmediatePropagation();
		}
		event.preventDefault();
	}



	const constructHeaderWithInfo = (valueObj)  => {
		const updateOverlay = (evt) => {
			setSelectedInfoButtonMessage(valueObj.detail);
			infoButtonsOverlay.current.show(evt);
		};
		return (
			<>
				{valueObj.label}
				{valueObj.detail &&
					<Button icon="pi pi-info" onClick={updateOverlay} onMouseEnter={updateOverlay} className='info' rounded/>
				}
			</>
		);
	}


	const templateCellBody = (rowData, valueObj)  => {
		const editComponent = valueObj.editComponent;
		if(valueObj?.inputType === "Button" && valueObj?.editComponent && valueObj?.key) {
			return (
			<>
				   <Button type="button" icon="pi pi-cog" label={valueObj?.label || ""} className="p-button-text" onClick={() => {
						const objectPathIndex = formik.values[name].findIndex(e => e?.step === rowData?.step);
						const propsEditComponent = {...editComponent.props, objectPath: name + "[" + objectPathIndex + "]", formik, name: valueObj?.key};
						setDisplayDialogEdit(true);

						setInnerComponentProps(propsEditComponent)}} />
				   <Dialog header={valueObj?.label} visible={displayDialogEdit} style={{ width: '70vw' }} onHide={() => {setDisplayDialogEdit(false)}} >
						<editComponent.type {...innerComponentProps}/>
					</Dialog>
			</>);
		}
		if(!valueObj?.key || !rowData[valueObj.key]) {
			return "-";
		} else if(typeof valueObj.inputOptions === "function" || valueObj.inputOptions?.length) {
			const options = typeof valueObj.inputOptions === "function"? valueObj.inputOptions(rowData): valueObj.inputOptions;
			const findObj = options.filter((e) => e.key === rowData[valueObj.key]);
			return findObj?.[0]?.label || "-";
		} else {
			return rowData[valueObj.key];
		}
	}


	const deleteRowBody = (rowData)  => {
		const deleteAction = (evt) => {
			evt.preventDefault();
			removeRow(rowData);
		};
		return <Button icon="pi pi-times" className='remove' onClick={deleteAction} rounded/>
	}

	const addRowSection = <div style={{textAlign: "right", margin: "0.7rem"}}>
							{!disabled &&
								<Button type="button" icon="pi pi-plus" label={addRowName || "Add New"} className="p-button-text" onClick={handleAddRow} text/>
							}
							</div>;

	return (

			<div id="steps_table" className="steps-table">

				{title && <h1>{title}</h1>}
				{description && <p>{description}</p>}

				<OverlayPanel ref={infoButtonsOverlay}>
						{selectedInfoButtonMessage}
				</OverlayPanel>

				{topAligned && addRowSection}
				<div className="mobile-horizontal-scrollable">
				<DataTable value={dataTableObj || []} editMode="cell" className="editable-cells-table" responsiveLayout="scroll" disabled={disabled}>
					<Column field="type" header={indexColumnName} style={{width: "15%"}} body={(rowData) => rowData.step} hidden={hideSteps} />
					{valuesList ?
						valuesList.map((valueObj) => {
							return (
							 <Column key={valueObj.key} field={valueObj.key}
							 	header={constructHeaderWithInfo(valueObj)} body={(rowData) => templateCellBody(rowData, valueObj)}
								editor={!disabled && valueObj?.inputType !== "Button"? (options) => textEditor(options, valueObj) : undefined}
								onCellEditComplete={onCellEditComplete} onCellEditCancel={onCellEditComplete} />
							);
						  })
						:
						<Column field="value" header={title} body={(rowData) => rowData.value || "-"}
								editor={!disabled? (options) => textEditor(options) : undefined}
								onCellEditComplete={onCellEditComplete} onCellEditCancel={onCellEditComplete}/>
					}
					{!disabled &&
						<Column field="delete" body={deleteRowBody}  />
					}
				</DataTable>
				</div>
				{!topAligned && addRowSection}
			</div>

	);
}

export default StepsTable;
